if (!customElements.get("byte-tabbed-products")) {
  class ByteTabbedProducts extends HTMLElement {
    constructor() {
      super();
      this.boundHandleSwatchClick = this.handleSwatchClick.bind(this);
      this.boundHandleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.boundHandleSwatchClick, true);
      // Sekme butonlarını dinle
      this.querySelectorAll('.js-tab-trigger').forEach(btn => {
        btn.addEventListener('click', this.boundHandleTabClick);
      });
    }

    // SEKME GEÇİŞ MANTIĞI
    handleTabClick(e) {
      const btn = e.currentTarget;
      const targetId = btn.getAttribute('data-target');
      const parent = btn.closest('byte-tabbed-products');

      // Butonları güncelle
      parent.querySelectorAll('.js-tab-trigger').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // İçerikleri güncelle
      parent.querySelectorAll('.js-tab-content').forEach(content => {
        if (content.id === targetId) {
          content.style.display = 'block';
          content.classList.add('active');
          
          // KRİTİK: Sekme açıldığında Flickity'i tazele (Birer birer kayması için şart)
          const slider = content.querySelector('.custom-flickity-slider');
          if (slider && typeof Flickity !== 'undefined') {
            const flkty = Flickity.data(slider);
            if (flkty) {
              flkty.resize();
              flkty.reposition();
            }
          }
        } else {
          content.style.display = 'none';
          content.classList.remove('active');
        }
      });
    }

    // RENK PALETİ MANTIĞI (Mevcut kodunuzu koruduk)
    handleSwatchClick(e) {
      const swatch = e.target.closest("a.element-swatch--link[data-variant-id]");
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      const card = swatch.closest(".grid-product");
      if (!card) return;

      const imageWrap = card.querySelector(".grid-product__image-wrap");
      const imageUrl = swatch.dataset.variantImageMain || swatch.dataset.variantImage;
      const imageAlt = swatch.dataset.variantImageAlt || null;
      const mainImgWrap = imageWrap?.querySelector("[data-product-card-main-image]");
      const mainImg = mainImgWrap?.querySelector("img");

      if (mainImg && imageUrl) {
        mainImg.src = imageUrl;
        mainImg.srcset = imageUrl + " 1x";
        if (imageAlt) mainImg.alt = imageAlt;
      }

      const colorSwatches = swatch.closest("color-swatches");
      if (colorSwatches) {
        colorSwatches.querySelectorAll(".element-swatch").forEach((s) => {
          s.classList.toggle("element-swatch--selected", s === swatch);
        });
      }
    }
  }

  customElements.define("byte-tabbed-products", ByteTabbedProducts);
}